var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereumIconPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "420.1 80.7 1079.8 1758.6",
    width: 983,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m959.8 80.7-539.7 895.6 539.7-245.3z",
    fill: "#8a92b2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m959.8 731-539.7 245.3 539.7 319.1zm539.8 245.3-539.8-895.6v650.3z",
    fill: "#62688f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m959.8 1295.4 539.8-319.1-539.8-245.3z",
    fill: "#454a75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m420.1 1078.7 539.7 760.6v-441.7z",
    fill: "#8a92b2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m959.8 1397.6v441.7l540.1-760.6z",
    fill: "#62688f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumIconPurple);
export default __webpack_public_path__ + "static/media/ethereum-icon-purple.5367532eda990a8646da45cbcd05ed03.svg";
export { ForwardRef as ReactComponent };